import React from 'react'
import { Col, Row, Switch } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import {
  Input,
  SelectCity,
  SelectCountry,
  SelectState
} from 'src/components/Formik'
import { Title } from 'src/components/Ant'

import { InitialValues } from '../initial-values'

interface Props {
  formikProps: FormikProps<InitialValues>
}

export default function UserAddress({ formikProps }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <Title level={4}>
        {t('web.user.common.address.title')}
        {!formikProps.values?.address?.address_id && (
          <Switch
            onChange={checked => {
              formikProps.setFieldValue(
                'address',
                checked
                  ? {
                      address_id: null,
                      address_number: null,
                      address: null,
                      city_id: null,
                      city: null,
                      country_id: null,
                      country: null,
                      description: null,
                      state_id: null,
                      state: null,
                      zip_code: null
                    }
                  : null
              )
            }}
            style={{ marginLeft: 16 }}
          />
        )}
      </Title>
      {!!formikProps.values.address && (
        <>
          <Row gutter={24}>
            <Col span={8}>
              <Input
                formikProps={formikProps}
                label="web.user.common.address.title"
                name="address.address"
                required={false}
              />
            </Col>
            <Col span={8}>
              <Input
                formikProps={formikProps}
                label="web.user.common.address_number.title"
                name="address.address_number"
                required={false}
              />
            </Col>
            <Col span={8}>
              <Input
                formikProps={formikProps}
                label="web.user.common.address_description.title"
                name="address.description"
                required={false}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <SelectCountry
                formikProps={formikProps}
                label="web.user.common.country.title"
                name="address.country_id"
                onChange={() => {
                  formikProps.setFieldValue('address.state', null)
                  formikProps.setFieldValue('address.state_id', null)
                  formikProps.setFieldValue('address.city', null)
                  formikProps.setFieldValue('address.city_id', null)
                }}
              />
            </Col>
            <Col span={8}>
              <SelectState
                country={
                  formikProps.values.address &&
                  formikProps.values.address.country_id
                }
                formikProps={formikProps}
                label="web.user.common.state.title"
                name="address.state_id"
                onChange={() => {
                  formikProps.setFieldValue('address.city', null)
                  formikProps.setFieldValue('address.city_id', null)
                }}
              />
            </Col>
            <Col span={8}>
              <SelectCity
                state={formikProps.values.address?.state_id}
                formikProps={formikProps}
                label="web.user.common.city.title"
                name="address.city_id"
              />
            </Col>
          </Row>
        </>
      )}
    </>
  )
}
